// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTExtendedCommonStatistic,
} from './';

/**
 * @export
 * @interface RESTSharePointBulkRestoreStatistics
 */
export interface RESTSharePointBulkRestoreStatistics {
    /**
     * Status of the restore operation.
     * @type {string}
     * @memberof RESTSharePointBulkRestoreStatistics
     */
    status?: RESTSharePointBulkRestoreStatisticsStatusEnum;
    /**
     * Restore operation details.
     * @type {Array<RESTExtendedCommonStatistic>}
     * @memberof RESTSharePointBulkRestoreStatistics
     */
    details?: Array<RESTExtendedCommonStatistic>;
    /**
     * Error occurred during the restore operation.
     * @type {string}
     * @memberof RESTSharePointBulkRestoreStatistics
     */
    error?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTSharePointBulkRestoreStatisticsStatusEnum {
    Failed = 'Failed',
    Warning = 'Warning',
    Success = 'Success'
}

